<template>
  <div id="app">
    <OnlineStatus @status="handleOnlineStatus"/>
    <top-nav/>
    <!-- <div class="page"> -->
      <el-container class="main">
        <el-aside width="auto" height="100%">
          <side-nav
            class="sidenav"
            :is-collapse="isCollapse"
            @hover="isCollapse = false"
            @unhover="isCollapse = true"
          />
        </el-aside>
        <el-container>
          <el-main>
            <slot>
              <router-view v-slot="{ Component, route }">
                <transition name="fade">
                  <component :is="Component" :key="route.path" />
                </transition>
              </router-view>
            </slot>
          </el-main>
        </el-container>
      </el-container>
      <el-dialog
        title="Connection not found"
        :visible.sync="onlineStatus"
        fullscreen
        :show-close="false"
        :close-on-press-escape="false"
        center
        :close-on-click-modal="false"
        :before-close="checkStatusBeforeClosing"
      >
        <el-card>
          <div slot="header">
            <RsLogo />
          </div>

          <div>
            <p>
              No Internet found!
            </p>
            <p>Reconnect to continue using RS platform.</p>
          </div>
        </el-card>
      </el-dialog>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav';
import SideNav from '@/components/SideNav';
import OnlineStatus from '@/components/OnlineStatus';
import RsLogo from '@/components/RSLogo';
import { registerSitemapSW } from './sw-sitemap-register';

export default {
  name: 'App',
  components: { TopNav, SideNav, OnlineStatus, RsLogo },
  created() {
    registerSitemapSW();
  },
  data() {
    return {
      isCollapse: true,
      onlineStatus: false,
    };
  },
  watch: {
    isCollapse(next, prev) {
      // Only fire after the sidenav has collapsed (expanded → collapsed), once
      // the 0.3s width transition has finished, so dependents (e.g. the Three.js
      // canvas in FacilityScene) can recalc their size against the now-wider
      // viewport.
      if (!(next === true && prev === false)) return;
      setTimeout(() => {
        this.$root.$emit('layout-resize');
      }, 300);
    },
  },
  methods: {
    handleOnlineStatus(status) {
      this.onlineStatus = !status;
    },
    checkStatusBeforeClosing(done) {
      if (this.onlineStatus) {
        return;
      }
      done();
    },
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
html, body {
  margin: 0;
}
.el-tooltip__popper {
  font-family: sans-serif;
}
* {
  word-break: break-word !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue